import { render, staticRenderFns } from "./SimpleRevision.vue?vue&type=template&id=5d64660a"
import script from "./SimpleRevision.vue?vue&type=script&lang=js"
export * from "./SimpleRevision.vue?vue&type=script&lang=js"
import style0 from "./SimpleRevision.vue?vue&type=style&index=0&id=5d64660a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports